import jsPDF from "jspdf";
import autoTable, { type RowInput } from "jspdf-autotable";
import type { ItemInfo } from "../models/item";
import fontAsset from "../assets/fonts/NotoSansDevanagari-Regular.ttf";
import { formatDate } from "./calculations";

const itemsPdfHeaders = [
	"Item Name",
	"Date",
	"Purchase Price",
	"Sell Price",
	"Avl. Qty.",
	"Item Code"
];

// const formatCurrency = (value: number) => `₹${value.toFixed(2)}`;

export const exportItemsListToPdf = (items: Record<string, ItemInfo>) => {
	const rows: RowInput[] = Object.values(items).map((item) => [
		item.name,
		formatDate(item.createdAt),
		item.purchasePrice.toFixed(2),
		item.sellPrice.toFixed(2),
		item.availableQuantity.toFixed(2),
		item.itemCode
	]);

	const doc = new jsPDF({
		orientation: "landscape",
		unit: "pt",
		format: "a4"
	});
	const pageWidth = doc.internal.pageSize.getWidth();
	const pageMargin = 24;

	doc.addFont(fontAsset, "NotoSansDevanagari", "normal");
	doc.setFont("NotoSansDevanagari", "normal");
	doc.setFontSize(16);
	doc.text("Inventory: Items List", pageMargin, 28);
	// add today's date to the top right corner
	const today = new Date();
	const dateStr = today.toLocaleDateString("en-IN", {
		day: "2-digit",
		month: "short",
		year: "numeric"
	});
	doc.setFontSize(10);
	doc.text(`Date: ${dateStr}`, pageWidth - pageMargin - 100, 28);
	autoTable(doc, {
		head: [itemsPdfHeaders],
		body: rows,
		startY: 42,
		styles: { font: "NotoSansDevanagari", fontSize: 8, cellPadding: 3 },
		headStyles: {
			fillColor: [41, 128, 185],
			textColor: 255,
			font: "NotoSansDevanagari"
		},
		margin: { left: pageMargin, right: pageMargin },
		tableWidth: pageWidth - pageMargin * 2,
		showHead: "everyPage"
	});

	const timestamp = new Date().toISOString().slice(0, 10);
	doc.save(`items-list_${timestamp}.pdf`);
};
